import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import ErrorBoundary from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Billing from "@/pages/Billing";
import Customers from "@/pages/Customers";
import Services from "@/pages/Services";
import Staff from "@/pages/Staff";
import Inventory from "@/pages/Inventory";
import Bookings from "@/pages/Bookings";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Layout from "@/components/Layout";
import AccessDenied from "@/components/AccessDenied";
import { SalonProfileProvider } from "@/contexts/SalonProfileContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("salon_token");
  if (!token) return <Navigate to="/login" replace />;
  const user = JSON.parse(localStorage.getItem("salon_user") || "{}");
  if (!user.id) return <Navigate to="/login" replace />;
  const role = (user.role || "stylist").toLowerCase();
  if (role === "owner") {
    return <Layout>{children}</Layout>;
  }
  if (!allowedRoles.includes(role)) {
    return <AccessDenied role={role} />;
  }
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <LanguageProvider>
    <ErrorBoundary>
    <BrowserRouter>
      <SalonProfileProvider>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute allowedRoles={["owner", "manager", "receptionist", "stylist"]}><Dashboard /></ProtectedRoute>} />
        <Route path="/billing" element={<ProtectedRoute allowedRoles={["owner", "manager", "receptionist"]}><Billing /></ProtectedRoute>} />
        <Route path="/customers" element={<ProtectedRoute allowedRoles={["owner", "manager", "receptionist"]}><Customers /></ProtectedRoute>} />
        <Route path="/services" element={<ProtectedRoute allowedRoles={["owner", "manager"]}><Services /></ProtectedRoute>} />
        <Route path="/staff" element={<ProtectedRoute allowedRoles={["owner", "manager"]}><Staff /></ProtectedRoute>} />
        <Route path="/inventory" element={<ProtectedRoute allowedRoles={["owner", "manager"]}><Inventory /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute allowedRoles={["owner", "manager"]}><Reports /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute allowedRoles={["owner"]}><Settings /></ProtectedRoute>} />
        <Route path="/bookings" element={<ProtectedRoute allowedRoles={["owner", "manager", "receptionist", "stylist"]}><Bookings /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </SalonProfileProvider>
    </BrowserRouter>
    </ErrorBoundary>
    </LanguageProvider>
  );
}

export default App;
